import request from '@/libs/request'

//基地 报告文本模版信息 列表
export function landBaseReportTextListApi (data) {
  return request({
    url: `landBase/landBaseReportText`,
    method: 'get',
    params: data
  })
}

//基地 报告文本模版信息 详情
export function landBaseReportTextInfoApi (id) {
  return request({
    url: `landBase/landBaseReportText/` + id,
    method: 'get'
  })
}

//基地 报告文本模版信息 编辑
export function landBaseReportTextSaveApi (data) {
  return request({
    url: `landBase/landBaseReportText`,
    method: 'post',
    data: data
  })
}


